import $ from 'jquery';

$(document).ready(function() {
    $('.js-game-loto-slider').slick({
        dots: false,
        slidesToShow: 1,
        centerMode: false,
        variableWidth: true,
        arrows: true,
        infinite: false,
        draggable: false,
        responsive: [
        {
            breakpoint: 700,
            settings: {
                dots: false,
                slidesToShow: 1,
                centerMode: false,
                variableWidth: true,
                arrows: true,
                infinite: false,
                draggable: false,
           }
        }
        ]
    });
    $(window).trigger('resize');
});


// WEBPACK FOOTER //
// ./src/js/pages/game-loto/game-loto-slider.js